// extracted by mini-css-extract-plugin
export default {"wrapper":"Complexity_wrapper__SM0PY","range":"Complexity_range__Rz477"};